import { useMemo, useCallback } from "react";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { useSelector } from "react-redux";
import { useClientsListQuery } from "@/hooks/queries/useClientsListQuery";
import isempty from "lodash/isEmpty";

export const useClients = (isDisabled) => {
  const masterId = useSelector(UserSelectors.getMasterId);
  const { data } = useClientsListQuery(
    { domain: "master", masterId },
    {
      isEnabled: Boolean(masterId) && !isDisabled,
    }
  );
  return useMemo(() => {
    if (isempty(data)) return [];
    return data.map(({ full_name, _id, avatar, sex, phone }) => ({
      value: _id,
      label: full_name,
      phone,
      avatar,
      sex,
    }));
  }, [data]);
};
export const useCanCreateMorePublicDiscountsForAll = ({
  activeDiscount,
  discounts,
}) =>
  useMemo(() => {
    const publicForAll = discounts.find(({ service, client }) => {
      return !client && !service;
    });
    if (!publicForAll) {
      return true;
    }
    if (activeDiscount) {
      return activeDiscount._id === publicForAll._id;
    }
  }, [activeDiscount, discounts]);
export const useCanCreateMorePublicDiscountsForService = ({
  activeDiscount,
  discounts,
}) =>
  useMemo(() => {
    const publicForService = discounts.find(({ service, client }) => {
      return !client && service;
    });
    if (!publicForService) {
      return true;
    }
    if (activeDiscount) {
      return activeDiscount._id === publicForService._id;
    }
  }, [activeDiscount, discounts]);
export const useGetAllowedClientsForService = ({
  clients,
  activeDiscount,
  discounts,
}) =>
  useMemo(() => {
    return clients.filter(({ value: _id }) => {
      if (activeDiscount?.service && activeDiscount?.client === _id) {
        return true;
      }
      const invalid = discounts.some(
        ({ client, service }) => service && client === _id
      );
      return !invalid;
    });
  }, [clients, activeDiscount, discounts]);
export const useGetAllowedClientsForAll = ({
  clients,
  activeDiscount,
  discounts,
}) =>
  useMemo(() => {
    return clients.filter(({ value: _id }) => {
      if (
        activeDiscount &&
        !activeDiscount.service &&
        activeDiscount?.client === _id
      ) {
        return true;
      }
      const invalid = discounts.some(
        ({ client, service }) => !service && client === _id
      );
      return !invalid;
    });
  }, [clients, activeDiscount, discounts]);
